import { Opcao } from './opcao';
import { PerguntaVinculada } from './pergunta-vinculada';

export class Pergunta {
  public id: number;
  public enunciado: string;
  public nomeUnico: string;
  public tipoResposta: number;
  public ativa: boolean;
  public categoria: number;
  public obrigatoria: boolean;
  public descricaoCombo: boolean;
  public filtro: boolean;
  public respostaBloqueada: boolean;
  public preenchimentoAutomatico: boolean;


  public ordem: number;
  public tamanhoMinimo: number;
  public tamanhoMaximo: number;
  public instrucao: string;
  public alerta: string;

  // variaveis transient
  public opcoes:Opcao[];
  public opcoesGenericas:Opcao[];
  public backgroundColor: string;

  public perguntaVinculada: PerguntaVinculada;

}
